import React from 'react'
import { Icon, Animation, PageTitle, PageContent, Heading, Text, Button, Style, Video, Tooltip } from 'components/library'
import './Page.css'

class Page extends React.Component {

  constructor(){
    super()

    this.state ={
      tooltip1Status: false,
    }
  }

  handleTooltipHover = id => {
    this.setState( prevState => ({
      [`tooltip${id}Status`]: prevState[`tooltip${id}Status`] ? false : true
    }))
  }


  render() {
    return (
      <div className="IntroductionPage">

        <Animation name="slideInDown" delay={100}>
          <PageTitle>
            <Heading h1>Goedemiddag {this.props.user.name}. Leer sleepbewegingen uitvoeren.</Heading>
          </PageTitle>
        </Animation>

        <Animation delay={200}>
          <PageContent nospacing>
            <Video vimeoId={342967907} videoHeight="49%"/>
            <div style={{ padding: '0 4rem 4rem', fontSize: '110%' }} >
              <div className="main">
                <div>
                  <Text>In deze e-Learning krijg je alle kennis aangeboden die noodzakelijk is voor het veilig uitvoeren van sleepbewegingen zoals beschreven in Handboek 1.2.4 Uitvoeren Sleepbewegingen.</Text>
                </div>
                <div style={{marginTop: '3rem'}}>
                  <Text style={{fontWeight: '600'}}>Voor wie?</Text>
                  <Text>Deze e-Learning is bedoeld voor jou als je in opleiding bent tot sleepchauffeur op Schiphol.</Text>
                </div>

                <div style={{marginTop: '3rem'}}>
                  <Text>In deze e-Learning leer je alleen de kennis die beschreven staat in Handboek 1.2.4 Uitvoeren Sleepbewegingen. De afspraken tussen de verschillende afhandelaren en luchtvaartmaatschappijen zijn niet in deze e-Learning meegenomen.</Text>
                </div>

                <div style={{marginTop: '3rem'}}>
                  <Text style={{fontWeight: '600'}}>Hoe</Text>
                  <Text>De e-learning bevat 5 hoofdstukken. In elk hoofdstuk wordt eerst de theorie behandeld, afsluitend worden een aantal praktijkopdrachten meegegeven.</Text>
                </div>

                <div style={{marginTop: '3rem'}}>
                  <Text>De e-learning duurt in totaal ongeveer 45 minuten.</Text>
                </div>

                <div style={{marginTop: '3rem'}}>
                  <Text style={{fontWeight: '600'}}>Geluid</Text>
                  <Text>Deze e-Learning bevat geluid. Zorg ervoor dat je deze e-Learning doorloopt op een PC of tablet waarmee je geluid kunt afspelen, of waar je een koptelefoon op kunt aansluiten.</Text>
                </div>

                <div style={{marginTop: '3rem'}}>
                  <Text style={{fontWeight: '600'}}>Zelftoets</Text>
                  <Text>Wanneer je alle hoofdstukken hebt doorlopen, ben je klaar voor de zelftoets. Deze zelftoets is een eerste check of je de kennis bezit die nodig is voor het behalen van de theorieprofcheck. De zelftoets dien je met een voldoende af te ronden voordat je je in kunt schrijven voor de theorieprofcheck. Als je de toets niet in een keer haalt, wordt je verwezen naar de hoofdstukken die we je aanraden om nogmaals door te nemen.</Text>
                </div>
              </div>
              <div style={{ textAlign: 'center', margin: '4rem 0 2rem' }}>
                <Button fixed square primary onClick={this.props.onSubmit} label="Aan de slag" />
              </div>
            <Style.Flex>
              <Icon name="clock" size="small" /><Text small>ongeveer 45 minuten</Text>
            </Style.Flex>
            <Style.Flex>
                <Text style={{ textAlign: 'center', margin: '4rem 0 2rem' }} small>Deze e-learning module is met de grootste zorg ontwikkeld. Desondanks kan het    Veiligheidstrainingcentrum Schiphol op geen enkele wijze aansprakelijk gesteld worden voor onjuistheden in haar lesmateriaal. Bij onjuistheden of onvolkomenheden zijn de brondocumenten van de Service Owner leidend.</Text>
              </Style.Flex>
            </div>
          </PageContent>
        </Animation>
      </div>
    )
  }
}


export default Page



// WEBPACK FOOTER //
// ./src/content/pages/introduction/Page.js